(function() {
    'use strict';

    angular
        .module('szallodak-supply', []);
})();
